export default __webpack_public_path__ + "static/media/hamburger.3e370278.webp";